<template>
  <section>
    <vue-highcharts type="chart" :options="options" class="custom-heartrate" />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import VueHighcharts from 'vue3-highcharts'
export default {
  name: 'session-heartrate-chart',
  components: {
    VueHighcharts,
  },
  computed: {
    ...mapGetters('usercardio', ['memberSession']),
    inzone() {
      let _data = {
        low: 0,
        high: 0,
      }
      if (this.memberSession) {
        _data = {
          low: this.memberSession.inzone.low,
          high: this.memberSession.inzone.high,
        }
      }
      console.log('InZone Data', _data)
      return _data
    },
    plotdata() {
      let _data = []
      if (this.memberSession) {
        _data = this.memberSession.plotdata
      }
      return _data
    },
    options() {
      let _options = {
        chart: {
          type: 'spline',
          animation: false,
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        xAxis: {
          type: 'number',
          labels: {
            enabled: true,
            formatter: function () {
              return parseInt(this.value / 60)
            },
          },
          title: {
            text: 'workout duration (min)',
          },
        },
        yAxis: {
          title: {
            text: 'beats per minute',
          },
          minorGridLineWidth: 0,
          gridLineWidth: 0,
          alternateGridColor: null,
          plotBands: [
            {
              // below zone
              from: 0,
              to: this.inzone.low,
              color: '#CDCDCD',
              label: {
                text: '',
                style: {
                  color: '#606060',
                },
              },
            },
            {
              // in zone
              from: this.inzone.low,
              to: this.inzone.high,
              color: '#B0D3F9',
              label: {
                text: '',
                style: {
                  color: '#606060',
                },
              },
            },
            {
              // above zone
              from: this.inzone.high,
              to: 500,
              color: '#FFC08A',
              label: {
                text: '',
                style: {
                  color: '#606060',
                },
              },
            },
          ],
        },
        tooltip: {
          valueSuffix: ' b/s',
          formatter: function () {
            var minutes = parseInt(this.x / 60)
            return (
              'HR at <b>' + minutes + '</b> min is <b>' + this.y + ' b/s</b>'
            )
          },
        },
        plotOptions: {
          spline: {
            lineWidth: 1,
            states: {
              hover: {
                lineWidth: 2,
              },
            },
            marker: {
              enabled: false,
            },
          },
        },
        series: [
          {
            name: '',
            data: this.plotdata,
            zones: [
              {
                value: this.inzone.low,
                color: '#A7A39E',
              },
              {
                value: this.inzone.high,
                color: '#006180',
              },
              {
                color: '#F98942',
              },
            ],
            animation: false,
          },
        ],
        navigation: {
          menuItemStyle: {
            fontSize: '10px',
          },
        },
      }
      console.log('Heart Rate Chart Options', _options)
      return _options
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-heartrate {
  width: 450px;
  height: 400px;
  margin: 0 auto;
}
</style>
